/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { httpClient } from "../../orval/http-client";
import type { ErrorType, BodyType } from "../../orval/http-client";
import { domainQueryKey } from "../../orval/query-key";
import type {
  CollectionResponse,
  CollectionUpsertRequest,
  CollectionsResponse,
  ErrorResponse,
} from "../model";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const addProposalToCollection = (
  collectionId: string,
  planningProposalsId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<CollectionResponse>(
    {
      url: `/planning-proposal/collection/${collectionId}/proposal/${planningProposalsId}`,
      method: "PUT",
      signal,
    },
    options,
  );
};

export const getAddProposalToCollectionMutationKey = () =>
  ["addProposalToCollection"] as const;

export const getAddProposalToCollectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addProposalToCollection>>,
    TError,
    AddProposalToCollectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addProposalToCollection>>,
  TError,
  AddProposalToCollectionMutationVariables,
  TContext
> => {
  const mutationKey = getAddProposalToCollectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addProposalToCollection>>,
    AddProposalToCollectionMutationVariables
  > = (props) => {
    const { collectionId, planningProposalsId } = props ?? {};

    return addProposalToCollection(
      collectionId,
      planningProposalsId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddProposalToCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addProposalToCollection>>
>;

export type AddProposalToCollectionMutationError = ErrorType<ErrorResponse>;
export type AddProposalToCollectionMutationVariables = {
  collectionId: string;
  planningProposalsId: string;
};

export const useAddProposalToCollection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addProposalToCollection>>,
      TError,
      AddProposalToCollectionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addProposalToCollection>>,
  TError,
  AddProposalToCollectionMutationVariables,
  TContext
> => {
  return useMutation(
    getAddProposalToCollectionMutationOptions(options),
    queryClient,
  );
};
export const removeProposalFromCollection = (
  collectionId: string,
  planningProposalsId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<CollectionResponse>(
    {
      url: `/planning-proposal/collection/${collectionId}/proposal/${planningProposalsId}`,
      method: "DELETE",
      signal,
    },
    options,
  );
};

export const getRemoveProposalFromCollectionMutationKey = () =>
  ["removeProposalFromCollection"] as const;

export const getRemoveProposalFromCollectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeProposalFromCollection>>,
    TError,
    RemoveProposalFromCollectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeProposalFromCollection>>,
  TError,
  RemoveProposalFromCollectionMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveProposalFromCollectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeProposalFromCollection>>,
    RemoveProposalFromCollectionMutationVariables
  > = (props) => {
    const { collectionId, planningProposalsId } = props ?? {};

    return removeProposalFromCollection(
      collectionId,
      planningProposalsId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveProposalFromCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeProposalFromCollection>>
>;

export type RemoveProposalFromCollectionMutationError =
  ErrorType<ErrorResponse>;
export type RemoveProposalFromCollectionMutationVariables = {
  collectionId: string;
  planningProposalsId: string;
};

export const useRemoveProposalFromCollection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeProposalFromCollection>>,
      TError,
      RemoveProposalFromCollectionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeProposalFromCollection>>,
  TError,
  RemoveProposalFromCollectionMutationVariables,
  TContext
> => {
  return useMutation(
    getRemoveProposalFromCollectionMutationOptions(options),
    queryClient,
  );
};
export const getProposalCollections = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<CollectionsResponse>(
    { url: `/planning-proposal/collection`, method: "GET", signal },
    options,
  );
};

export const getGetProposalCollectionsQueryKey = () =>
  domainQueryKey({}, { url: `/planning-proposal/collection` });

export const useGetProposalCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProposalCollections>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getProposalCollections>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    {},
    { url: `/planning-proposal/collection`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProposalCollections>>
  > = ({ signal }) => getProposalCollections(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProposalCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProposalCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProposalCollections>>
>;
export type GetProposalCollectionsQueryError = ErrorType<ErrorResponse>;

export function useGetProposalCollections<
  TData = Awaited<ReturnType<typeof getProposalCollections>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProposalCollections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProposalCollections>>,
          TError,
          Awaited<ReturnType<typeof getProposalCollections>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProposalCollections<
  TData = Awaited<ReturnType<typeof getProposalCollections>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProposalCollections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProposalCollections>>,
          TError,
          Awaited<ReturnType<typeof getProposalCollections>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProposalCollections<
  TData = Awaited<ReturnType<typeof getProposalCollections>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProposalCollections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProposalCollections<
  TData = Awaited<ReturnType<typeof getProposalCollections>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProposalCollections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetProposalCollectionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const createProposalCollection = (
  collectionUpsertRequest: BodyType<CollectionUpsertRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<CollectionResponse>(
    {
      url: `/planning-proposal/collection`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionUpsertRequest,
      signal,
    },
    options,
  );
};

export const getCreateProposalCollectionMutationKey = () =>
  ["createProposalCollection"] as const;

export const getCreateProposalCollectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProposalCollection>>,
    TError,
    CreateProposalCollectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProposalCollection>>,
  TError,
  CreateProposalCollectionMutationVariables,
  TContext
> => {
  const mutationKey = getCreateProposalCollectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProposalCollection>>,
    CreateProposalCollectionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createProposalCollection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProposalCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProposalCollection>>
>;
export type CreateProposalCollectionMutationBody =
  BodyType<CollectionUpsertRequest>;
export type CreateProposalCollectionMutationError = ErrorType<ErrorResponse>;
export type CreateProposalCollectionMutationVariables = {
  data: BodyType<CollectionUpsertRequest>;
};

export const useCreateProposalCollection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProposalCollection>>,
      TError,
      CreateProposalCollectionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProposalCollection>>,
  TError,
  CreateProposalCollectionMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateProposalCollectionMutationOptions(options),
    queryClient,
  );
};
export const deleteProposalCollection = (
  collectionId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/planning-proposal/collection/${collectionId}`,
      method: "DELETE",
      signal,
    },
    options,
  );
};

export const getDeleteProposalCollectionMutationKey = () =>
  ["deleteProposalCollection"] as const;

export const getDeleteProposalCollectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProposalCollection>>,
    TError,
    DeleteProposalCollectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProposalCollection>>,
  TError,
  DeleteProposalCollectionMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteProposalCollectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProposalCollection>>,
    DeleteProposalCollectionMutationVariables
  > = (props) => {
    const { collectionId } = props ?? {};

    return deleteProposalCollection(collectionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProposalCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProposalCollection>>
>;

export type DeleteProposalCollectionMutationError = ErrorType<ErrorResponse>;
export type DeleteProposalCollectionMutationVariables = {
  collectionId: string;
};

export const useDeleteProposalCollection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProposalCollection>>,
      TError,
      DeleteProposalCollectionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProposalCollection>>,
  TError,
  DeleteProposalCollectionMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteProposalCollectionMutationOptions(options),
    queryClient,
  );
};
export const renameProposalCollection = (
  collectionId: string,
  collectionUpsertRequest: BodyType<CollectionUpsertRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<CollectionResponse>(
    {
      url: `/planning-proposal/collection/${collectionId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: collectionUpsertRequest,
      signal,
    },
    options,
  );
};

export const getRenameProposalCollectionMutationKey = () =>
  ["renameProposalCollection"] as const;

export const getRenameProposalCollectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameProposalCollection>>,
    TError,
    RenameProposalCollectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameProposalCollection>>,
  TError,
  RenameProposalCollectionMutationVariables,
  TContext
> => {
  const mutationKey = getRenameProposalCollectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameProposalCollection>>,
    RenameProposalCollectionMutationVariables
  > = (props) => {
    const { collectionId, data } = props ?? {};

    return renameProposalCollection(collectionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameProposalCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameProposalCollection>>
>;
export type RenameProposalCollectionMutationBody =
  BodyType<CollectionUpsertRequest>;
export type RenameProposalCollectionMutationError = ErrorType<ErrorResponse>;
export type RenameProposalCollectionMutationVariables = {
  collectionId: string;
  data: BodyType<CollectionUpsertRequest>;
};

export const useRenameProposalCollection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameProposalCollection>>,
      TError,
      RenameProposalCollectionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameProposalCollection>>,
  TError,
  RenameProposalCollectionMutationVariables,
  TContext
> => {
  return useMutation(
    getRenameProposalCollectionMutationOptions(options),
    queryClient,
  );
};
